import { render, staticRenderFns } from "./AppUpdate.vue?vue&type=template&id=1120732c"
import script from "./AppUpdate.vue?vue&type=script&lang=ts"
export * from "./AppUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports